import { motion } from "framer-motion";

import { heroFlow, heroHighlights } from "./landingContent";
import { FlowIcon, LandingButton, LandingCard } from "./LandingPrimitives";

export default function LandingHeroSection() {
  return (
    <section id="top" className="landing-hero">
      <div className="landing-shell landing-hero__grid">
        <div className="landing-hero__copy">
          <h1>
            Aplicație pentru <span>foi de parcurs online</span>, completate automat.
          </h1>

          <p className="landing-hero__lead">
            Nu mai pierde bani, timp sau liniște din cauza foilor de parcurs. Pentru mulți,
            deducerea 100% a părut prea complicată sau prea riscantă, așa că au rămas la 50%.
            Dar, într-un context cu taxe mai mari și costuri auto tot mai ridicate, diferența nu mai
            poate fi ignorată. AIFoiParcurs te ajută să susții mai ușor deductibilitatea integrală,
            fără muncă manuală zi de zi.
          </p>

          <div className="landing-hero__actions">
            <LandingButton href="/login">Testează gratuit</LandingButton>
            <LandingButton href="/#solutia" variant="secondary">
              Vezi cum funcționează
            </LandingButton>
          </div>

          <p className="landing-note">Fără card - Activare instant</p>

          <div className="landing-highlight-grid">
            {heroHighlights.map((item) => (
              <div key={item} className="landing-highlight-card">
                <p>{item}</p>
              </div>
            ))}
            <div className="landing-highlight-card landing-highlight-card--mobile">
              <p>Pentru firme și PFA-uri care vor să lucreze mai inteligent</p>
            </div>
          </div>

          <div className="landing-chip landing-chip--soft landing-hero__chip">
            Pentru firme și PFA-uri care vor să lucreze mai inteligent
          </div>
        </div>

        <div className="landing-hero__aside">
          <div className="landing-motion-stage">
          <div className="landing-orb landing-orb--violet" />
          <div className="landing-orb landing-orb--sky" />

          <motion.div
            animate={{ rotateX: [9, 6, 9], rotateY: [-8, -5, -8], y: [0, -6, 0] }}
            transition={{ duration: 8, repeat: Number.POSITIVE_INFINITY, ease: "easeInOut" }}
            className="landing-motion-card"
          >
            <LandingCard glow className="landing-hero-card">
              <div className="landing-hero-card__surface">
                <div className="landing-hero-card__header">
                  <p className="landing-hero-card__title">AIFoiParcurs</p>
                  <p className="landing-hero-card__subtitle">Gestionează automat foile de parcurs</p>
                </div>

                <div className="landing-hero-card__intro">
                  <p className="landing-hero-card__intro-title">Intri în platformă</p>
                  <p className="landing-hero-card__intro-subtitle">Activezi contul în câteva minute</p>
                </div>

                <div className="landing-hero-flow-grid">
                  {heroFlow.slice(0, 2).map((item) => (
                    <div key={item.description} className="landing-hero-flow-card">
                      <div className="landing-hero-flow-card__icon">
                        <FlowIcon icon={item.icon} className="landing-icon" />
                      </div>
                      <p>{item.description}</p>
                    </div>
                  ))}
                </div>

                <div className="landing-hero-flow-card landing-hero-flow-card--featured">
                  <div className="landing-hero-flow-card__row">
                    <div className="landing-hero-flow-card__icon landing-hero-flow-card__icon--featured">
                      <FlowIcon icon={heroFlow[2].icon} className="landing-icon" />
                    </div>
                    <p>{heroFlow[2].description}</p>
                  </div>
                </div>

                <div className="landing-hero-flow-card landing-hero-flow-card--success">
                  <div className="landing-hero-flow-card__row">
                    <div className="landing-hero-flow-card__icon landing-hero-flow-card__icon--success">
                      <FlowIcon icon={heroFlow[3].icon} className="landing-icon landing-icon--small" />
                    </div>
                    <p>{heroFlow[3].description}</p>
                  </div>
                </div>
              </div>
            </LandingCard>
          </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
